import { ProgressBar } from '@sgme/ui';
import { Layout } from 'components/missed-deal-feedback/components/layout';
import { SubmissionStatus } from 'components/missed-deal-feedback/components/submission-status';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { FormattedMessage } from 'react-intl';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackRequestedThunk } from 'state/missed-deal-feeedback/thunk';

export function MissedDealFeedbackLoadingFailedForm({ formId }: FormIdProps) {
  const dispatch = useThunkDispatch();

  return (
    <Layout.Wrapper>
      <Layout.Body />
      <SubmissionStatus color="error" iconName="info_outline" textIntlKey="missedDealFeedback.generic.error.message">
        <button
          className="btn btn-primary"
          data-e2e="missedDealFeedback-retry-button"
          onClick={() => dispatch(missedDealFeedbackRequestedThunk(formId))}
        >
          <FormattedMessage id="missedDealFeedback.retry" />
        </button>
      </SubmissionStatus>
      <ProgressBar size="md" color="danger" value={0} />
    </Layout.Wrapper>
  );
}
